import { Injectable } from '@angular/core';

import { Store } from '@ngxs/store';

import { ProjectSelectors } from '../project/project.selectors';

@Injectable({
  providedIn: 'root',
})
export class ProjectDocumentsFacade {
  documents = this.store.selectSignal(ProjectSelectors.projectDocuments);
  documents$ = this.store.select(ProjectSelectors.projectDocuments);

  constructor(private readonly store: Store) {}
}
